import { render, staticRenderFns } from "./order-detail.vue?vue&type=template&id=980d1afe&scoped=true"
import script from "./order-detail.vue?vue&type=script&lang=js"
export * from "./order-detail.vue?vue&type=script&lang=js"
import style0 from "./order-detail.vue?vue&type=style&index=0&id=980d1afe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980d1afe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('980d1afe')) {
      api.createRecord('980d1afe', component.options)
    } else {
      api.reload('980d1afe', component.options)
    }
    module.hot.accept("./order-detail.vue?vue&type=template&id=980d1afe&scoped=true", function () {
      api.rerender('980d1afe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Order/order-detail.vue"
export default component.exports